import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA,MatDialog as MatDialog,MatDialogConfig as MatDialogConfig,MatDialogRef as MatDialogRef } from "@angular/material/dialog";

import { MediaService } from "src/app/new-media/common/media.service";
import { SiteService } from "src/app/services/site.service";
import { AddEditFolderComponent } from "../../../folders/add-edit-folder/add-edit-folder.component";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-move-dialog",
  templateUrl: "./move-dialog.component.html",
  styleUrls: ["./move-dialog.component.css"],
})
export class MoveDialogComponent implements OnInit {
  selectedMedia: any;
  public form = new FormGroup({
    id: new FormControl(0),
    parentId: new FormControl(null),
    title: new FormControl("", [Validators.required]),
    order: new FormControl("", [Validators.min(0)]),
    description: new FormControl(""),
    cultureId: new FormControl("", [Validators.required]),
  });
  openedParentFolders = new Map();
  foldersNotAllowed = new Map();
  selectedFolders: any;
  selectedFolder;
  constructor(
    public siteService: SiteService,
    public mediaManagerService: MediaService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<MoveDialogComponent>,

    @Inject(MAT_DIALOG_DATA) data,
    private snotifyService: ToastrService,
  ) {
    this.selectedMedia = data.selectedMedia;
    this.selectedFolders = data.selectedFolders;
  }
  folderSelected:any

  media
  folders
  ngOnInit() {
    // this.setFoldersOfSelectedItems()
 this.mediaManagerService.allSideFolders$.subscribe((ress)=>{console.log(ress)})
    console.log('/////////////////////')
    console.log(this.selectedFolders)

     let folderSelected = Array.from(this.selectedFolders).map(([key, value]) => ({ key, value }));
this.folders=folderSelected
let mediaSelected = Array.from(this.selectedMedia).map(([key, value]) => ({ key, value }));
this.media=mediaSelected


  }
  manageFolder(method) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    // dialogConfig.panelClass = "modal-media";

    dialogConfig.data = {
      method: method,
      folder: this.mediaManagerService.folder,
    };
    this.dialog
      .open(AddEditFolderComponent, dialogConfig)
      .afterClosed()
      .subscribe((res) => {});
  }
  move() {
    if(!this.toggleRoot){
      if (this.selectedMedia.size) {
        this.moveMedia();
        this.mediaManagerService.getFoldersFirstTime()
  
      }
      if (this.selectedFolders.size) {
        this.moveFolders();
        this.mediaManagerService.getFoldersFirstTime()
  
      }
    }else{    if (this.selectedMedia.size) {
      this.mediaManagerService
      .moveMedia([...this.selectedMedia.keys()], null)
      .subscribe((res) => {
        this.close("submit");
      });      this.mediaManagerService.getFoldersFirstTime()

    }
    if (this.selectedFolders.size) {
      this.mediaManagerService
      .moveFolders([...this.selectedFolders.keys()], null)
      .subscribe(() => {
        this.close("submit");
      });
      this.mediaManagerService.getFoldersFirstTime()

    }}
   
  }
  moveMedia() {
    this.mediaManagerService
      .moveMedia([...this.selectedMedia.keys()], this.mediaManagerService.folder.parentId)
      .subscribe((res) => {
        this.close("submit");
      });
  }
  toggleRoot=false
  selectRoot(){
    console.log(this.selectedFolders)
    this.selectedFolder={}
    this.emptyFolders()
    this.toggleRoot=!this.toggleRoot

  
  }
  moveFolders() {
    this.mediaManagerService
      .moveFolders([...this.selectedFolders.keys()], this.mediaManagerService.folder.parentId)
      .subscribe(() => {
        this.close("submit");
      });
  }

  moveFoldersToRoot() {
    this.mediaManagerService
      .moveFolders([...this.selectedFolders.keys()],null)
      .subscribe(() => {
        this.close("submit");
      });
  } 
  close(event) {
    this.dialog.closeAll();
    this.dialogRef.close(event);
  }
  setFoldersOfSelectedItems() {
    for (let key of this.selectedFolders.keys()) {
      let folder = this.selectedFolders.get(key);
      if (folder.folderId)
        this.foldersNotAllowed.set(folder.folderId, folder.folderId);
    }

    for (let key of this.selectedMedia.keys()) {
      var media = this.selectedMedia.get(key);
      if (media.folderId)
        this.foldersNotAllowed.set(media.folderId, media.folderId);
    }
  }

  openSubFolder(event, folder) {
       event.stopPropagation();
    if (this.openedParentFolders.get(folder.id))
      this.openedParentFolders.delete(folder.id);
    else this.openedParentFolders.set(folder.id, folder);
  }
  setSelectedFolder(folder) {
       this.toggleRoot=false
    this.selectedFolder = folder;
    this.mediaManagerService.isParentIdChanged(
      folder.id,
      folder.name,
      folder.parentFolderId,
      folder.itemCount,
      folder.currentFolderBreadcrumb
    );
  }
  emptyFolders() {
    this.selectedFolder = null;
    this.mediaManagerService.folder = {};
  }
}
